import React from "react";
import { Link } from "react-router-dom";
import "./Contact.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";
import {
  faLocationDot,
  faEnvelope,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { useLanguage } from "../../i18n/LanguageContext";
import { contact, footer } from "../../i18n/content";

const Contact = () => {
  const { t } = useLanguage();

  return (
    <div className="contact_test_wrapper">
      <header className="lw-page-hero">
        <div className="lw-wrap">
          <div className="lw-eyebrow">
            <span className="lw-dot" />
            {t(contact.eyebrow)}
          </div>
          <h1>{t(contact.title)}</h1>
          <p>{t(contact.lede)}</p>
        </div>
      </header>

      <section className="lwt-contact-body">
        <div className="lw-wrap lwt-contact-grid">
          <div className="lwt-map">
            <iframe
              title={t(contact.mapTitle)}
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1028.6711423251847!2d42.19022700647591!3d41.626587160380154!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x405d5b8c79434107%3A0x306ec2b58be08dc4!2sShuakhevi%20municipal%20office!5e1!3m2!1sen!2sge!4v1712178551451!5m2!1sen!2sge"
              width="100%"
              height="100%"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <div className="lwt-contact-info">
            <div className="lwt-info-block">
              <h3>
                <FontAwesomeIcon icon={faLocationDot} /> {t(contact.visit)}
              </h3>
              <p>{t(contact.address)}</p>
            </div>
            <div className="lwt-info-block">
              <h3>
                <FontAwesomeIcon icon={faEnvelope} /> {t(contact.email)}
              </h3>
              <a href="mailto:cinephoneadjaraff@gmail.com">
                cinephoneadjaraff@gmail.com
              </a>
            </div>
            <div className="lwt-info-block">
              <h3>
                <FontAwesomeIcon icon={faPhone} /> {t(contact.call)}
              </h3>
              <a href="tel:+995597780501">+995 597 780 501</a>
              <br />
              <a href="tel:+995591712141">+995 591 712 141</a>
            </div>
            <div className="lwt-info-block">
              <h3>{t(contact.follow)}</h3>
              <a
                href="https://www.facebook.com/adjarianfilmtales"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faFacebookF} /> Facebook
              </a>
              <br />
              <a
                href="https://www.instagram.com/adjarianfilmtales/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faInstagram} /> Instagram
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="lw-footer">
        <div className="lw-wrap lw-foot-bottom">
          <span>{t(footer.est)}</span>
          <Link to="/">{t(footer.backHome)}</Link>
        </div>
      </footer>
    </div>
  );
};

export default Contact;
